import { ChatType, FrontendPageEnum } from "shared/model/pages";

import { LandbotChat } from "../components/chat/landbot/landbot-chat";
import { usePageSettings } from "../tenant-settings";

export const Chat: React.FC = () => {
  const chatSettings = usePageSettings(FrontendPageEnum.CHAT);

  if (!chatSettings?.chatType) {
    return null;
  }
  switch (chatSettings.chatType) {
    case ChatType.LANDBOT:
      return <LandbotChat />;
    case ChatType.AI:
      return <div>{"empty"}</div>;
  }
};
